import Loader from "../components/loader";
import WebLaout from "../layout/WebLayout";
import NoRecord from "../components/NoRecord";
import { useEffect, useRef, useState } from "react";
import AssetCard from "../components/pages/AssetCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchPublicAssets } from "../redux/actions/assetAction";
import { statusValueDefine, tabs } from "../utils/pip";
import CategoryDropdown from "../components/CategoryDropdown";
import { useNavigate } from "react-router-dom";
import { webPaths } from "../routes/pageRoutes";

const WebHome = () => {
  const dispatch = useDispatch();
  const bannerRef = useRef(null);
  const navigate = useNavigate()
  const { isLoading, assetList, assetCategoryList } = useSelector(
    (state) => state.assetReducer,
  );
    const bannerImageRef = useRef(null);
  const [categoryId, setCategoryId] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchSubmitted, setIsSearchSubmitted] = useState(false);
  const [showHomeSearch, setShowHomeSearch] = useState(true);

  const [activeTab, setActiveTab] = useState(tabs[0]?.lable);
const [bannerActive, setBannerActive] = useState(false);
 
const handleTabClick = (label) => {
  setActiveTab(label);
  setBannerActive(false);
 
  setTimeout(() => {
    setBannerActive(true);
  }, 50);
};
 
 
  useEffect(() => {
    const handleScroll = () => {
      setShowHomeSearch(window.scrollY <= 425);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    dispatch(
      fetchPublicAssets({
        search: searchQuery || "",
        categoryId: categoryId || "",
      }),
    );
  }, [categoryId, searchQuery, dispatch]);

  
    useEffect(() => {
      const bannerImage = bannerImageRef.current;
  
      if (!bannerImage) {
        return undefined;
      }
  
      bannerImage.classList.remove("active");
      void bannerImage.offsetWidth;
      bannerImage.classList.add("active");
  
      return undefined;
    }, [activeTab]);
  


  const handleSearch = () => {
    const trimmedSearch = searchFilter.trim();
    setSearchFilter(trimmedSearch);
    setSearchQuery(trimmedSearch);
    setIsSearchSubmitted(Boolean(trimmedSearch));
  };

  const handleClearSearch = () => {
    setSearchFilter("");
    setSearchQuery("");
    setIsSearchSubmitted(false);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <WebLaout
      categoryId={categoryId}
      searchFilter={searchFilter}
      assetCategoryList={assetCategoryList}
      onCategoryChange={setCategoryId}
      onSearchChange={setSearchFilter}
      onSearch={handleSearch}
      onClearSearch={handleClearSearch}
      isSearchSubmitted={isSearchSubmitted}
    >
      <section class="ct_home_banner" ref={bannerRef}>
        <div class="container">
          <div class="row align-items-center ">
            <div class="col-xl-7">
              <div className={`ct_banner_title ${bannerActive ? "active" : ""}`}>

                <h2 class="ct_switzer_bold  ct_fs_44 ">
                  {statusValueDefine[activeTab]?.title}
                </h2>

                <p
                  class="mb-0 ct_text_clr_4B5563  ct_fs_20 "
                  style={{ maxWidth: "909px" }}
                >
                  {statusValueDefine[activeTab]?.description}
                </p>

                <div
                  className={`ct_search_filter_main ${showHomeSearch ? "" : "ct_opacity_none"}`}
                >
                  <ul>
                   {tabs?.map((item, ind) => (
                    <li
                      key={ind}
                      onClick={() => handleTabClick(item?.lable)}
                        className="ct_cursor_pointer"
                      >
                        <button
                          className={activeTab == item?.lable ? "active" : ""}
                        >
                          {item?.svg}
                        </button>
                        <small className="ct_text_4f4f4f opacity-75 mt-2">
                          {item?.lable}
                        </small>
                      </li>
                    ))}
                  </ul>

                  <div class="ct_banner_search_filters">
                    <CategoryDropdown
                      value={categoryId}
                      options={assetCategoryList}
                      onChange={setCategoryId}
                      className="ct_select_w_177 ct_w_100_575"
                      buttonClassName="ct_input border-0 opacity-75"
                      style={{ backgroundColor: "transparent", height: "50px" }}
                    />
                    <div class="position-relative ct_search">
                      <input
                        type="text"
                        class="form-control ct_input ct_pe_168"
                        style={{
                          boxShadow: "0px 0px 9px 0px #00000040",
                          height: "50px",
                          paddingRight: "90px",
                        }}
                        placeholder="Search assets"
                        value={searchFilter}
                        onChange={(e) => setSearchFilter(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSearch();
                          }
                        }}
                      />
                      <div className="ct_show_eye d-flex align-items-center gap-3" style={{right:"5px"}}>
                         {isSearchSubmitted && searchFilter && <button
                        type="button"
                        className="ct_search_clear_btn"
                        aria-label="Clear search"
                        onClick={handleClearSearch}
                      >
                        <i class="fa-solid fa-xmark"></i>
                      </button>}
                        <button
                    class="ct_green_bnt  px-3 py-2"
                    type="button"
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                      </div>
                    </div>

                  
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 ps-xl-4 d-none d-xl-block">
              <div className="ct_home_banner_side_img">
                <img
                  ref={bannerImageRef}
                  src={statusValueDefine[activeTab]?.img}
                  // className="active"
                  alt={statusValueDefine[activeTab]?.title || "banner"}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="mt-5">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div className="d-flex align-items-center justify-content-between mb-4">
                <div>
                  <h4 class="ct_fs_32 ct_switzer_bold mb-1">
                    {" "}
                    Featured Assets
                  </h4>
                  <p class="mb-0 ct_text_clr_4B5563">
                    Premium assets available for acquisition
                  </p>
                </div>

                <div>
                  <a onClick={(e)=>{
                    e.preventDefault()
                    navigate(webPaths?.AllAssets)
                  }} className="ct_text_clr_4B5563 ct_fw_700">
                    View More <i class="fa-solid fa-chevron-right ms-2"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="ct_assets_data ct_custom_scroll pb-4">
            <div class="row ">
              {assetList?.length > 0 ? (
                assetList?.map((item, index) => (
                  <AssetCard
                    data={
                      item
                      //   {
                      //   promote: 1,
                      //   AssetImages: [
                      //     {
                      //       image_url: "/assets/img/assets_1.png",
                      //     },
                      //   ],
                      //   id: index + 1,
                      //   latitude: "",
                      //   longitude: "",
                      //   lock: index % 2 == 0 ? 1 : 0,
                      //   UIC: "6568520",
                      //   AssetName: "iPhone 15",
                      //   isStolen: index % 2 == 0 ? true : false,
                      //   AssetDetails:
                      //     "This property is not available for sale. Kindly...",
                      // }
                    }
                  />
                ))
              ) : (
                <NoRecord />
              )}
            </div>
          </div>
        </div>
      </section>

      <section class="securepoint-section ct_py_80 mt-5">
        <div class="container text-center">
          {/* Heading */}
          <h2 class="ct_fs_32 ct_switzer_Semibold mb-2">
            How SecurPoint Works
          </h2>
          <p class="ct_fs_20 ct_text_clr_4B5563 mb-5">
            Three simple steps to secure your digital assets
          </p>

          {/* Steps Row */}
          <div class="row g-4 justify-content-center">
            {/* Step 1 */}
            <div class="col-lg-4 col-md-6">
              <div class="step-box">
                <div class="icon-box">
                  <svg
                    width="30"
                    height="24"
                    viewBox="0 0 30 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_111_3881)">
                      <path
                        d="M4.5 6C4.5 4.4087 5.13214 2.88258 6.25736 1.75736C7.38258 0.632141 8.9087 0 10.5 0C12.0913 0 13.6174 0.632141 14.7426 1.75736C15.8679 2.88258 16.5 4.4087 16.5 6C16.5 7.5913 15.8679 9.11742 14.7426 10.2426C13.6174 11.3679 12.0913 12 10.5 12C8.9087 12 7.38258 11.3679 6.25736 10.2426C5.13214 9.11742 4.5 7.5913 4.5 6ZM0 22.6078C0 17.9906 3.74063 14.25 8.35781 14.25H12.6422C17.2594 14.25 21 17.9906 21 22.6078C21 23.3766 20.3766 24 19.6078 24H1.39219C0.623438 24 0 23.3766 0 22.6078ZM23.625 14.625V11.625H20.625C20.0016 11.625 19.5 11.1234 19.5 10.5C19.5 9.87656 20.0016 9.375 20.625 9.375H23.625V6.375C23.625 5.75156 24.1266 5.25 24.75 5.25C25.3734 5.25 25.875 5.75156 25.875 6.375V9.375H28.875C29.4984 9.375 30 9.87656 30 10.5C30 11.1234 29.4984 11.625 28.875 11.625H25.875V14.625C25.875 15.2484 25.3734 15.75 24.75 15.75C24.1266 15.75 23.625 15.2484 23.625 14.625Z"
                        fill="#32CD30"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_111_3881">
                        <path d="M0 0H30V24H0V0Z" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <h6 class="ct_fs_24 ct_switzer_Semibold mt-4 mb-4 ct_text_4f4f4f">
                  1. Create Account
                </h6>
                <p
                  class="ct_text_clr_4B5563 mb-0 mx-auto"
                  style={{ maxWidth: "342px" }}
                >
                  Set up your secure account with multi-factor authentication
                  and biometric verification for maximum protection.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div class="col-lg-4 col-md-6">
              <div class="step-box">
                <div class="icon-box">
                  <svg
                    width="30"
                    height="32"
                    viewBox="0 0 30 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M30 32H0V0H30V32Z" stroke="#E5E7EB" />
                    <g clip-path="url(#clip0_111_3888)">
                      <path
                        d="M27.1781 15.5484C29.8266 12.9 29.8266 8.61095 27.1781 5.96251C24.8344 3.61876 21.1406 3.31407 18.4453 5.24064L18.3703 5.2922C17.6953 5.77501 17.5406 6.71251 18.0235 7.38282C18.5063 8.05314 19.4438 8.21251 20.1141 7.7297L20.1891 7.67814C21.6938 6.6047 23.7516 6.77345 25.0547 8.08126C26.5313 9.55782 26.5313 11.9484 25.0547 13.425L19.7953 18.6938C18.3188 20.1703 15.9281 20.1703 14.4516 18.6938C13.1438 17.3859 12.975 15.3281 14.0485 13.8281L14.1 13.7531C14.5828 13.0781 14.4235 12.1406 13.7531 11.6625C13.0828 11.1844 12.1406 11.3391 11.6625 12.0094L11.611 12.0844C9.67971 14.775 9.9844 18.4688 12.3281 20.8125C14.9766 23.461 19.2656 23.461 21.9141 20.8125L27.1781 15.5484ZM2.8219 14.4516C0.173462 17.1 0.173462 21.3891 2.8219 24.0375C5.16565 26.3813 8.8594 26.686 11.5547 24.7594L11.6297 24.7078C12.3047 24.225 12.4594 23.2875 11.9766 22.6172C11.4938 21.9469 10.5563 21.7875 9.88596 22.2703L9.81096 22.3219C8.30627 23.3953 6.24846 23.2266 4.94534 21.9188C3.46877 20.4375 3.46877 18.0469 4.94534 16.5703L10.2047 11.3063C11.6813 9.8297 14.0719 9.8297 15.5485 11.3063C16.8563 12.6141 17.025 14.6719 15.9516 16.1766L15.9 16.2516C15.4172 16.9266 15.5766 17.8641 16.2469 18.3422C16.9172 18.8203 17.8594 18.6656 18.3375 17.9953L18.3891 17.9203C20.3203 15.225 20.0156 11.5313 17.6719 9.18751C15.0235 6.53907 10.7344 6.53907 8.08596 9.18751L2.8219 14.4516Z"
                        fill="#32CD30"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_111_3888">
                        <path d="M0 3H30V27H0V3Z" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <h6 class="ct_fs_24 ct_switzer_Semibold mt-4 mb-4 ct_text_4f4f4f">
                  2. Connect Assets
                </h6>
                <p
                  class="ct_text_clr_4B5563 mb-0 mx-auto"
                  style={{ maxWidth: "342px" }}
                >
                  Securely link your wallets, exchanges, and digital assets
                  through our encrypted API connections.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div class="col-lg-4 col-md-6">
              <div class="step-box">
                <div class="icon-box">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_111_3897)">
                      <path
                        d="M7.33594 20.9859L6.74531 22.3688C5.86875 21.9234 5.0625 21.375 4.33125 20.7328L5.39531 19.6688C5.98125 20.1797 6.63281 20.625 7.33594 20.9859ZM1.90312 12.75H0.398438C0.464062 13.7437 0.651563 14.7047 0.946875 15.6141L2.34375 15.0563C2.11406 14.3203 1.95937 13.5469 1.90312 12.75ZM1.90312 11.25C1.96875 10.3687 2.14688 9.51562 2.42344 8.71406L1.04063 8.12344C0.689063 9.10781 0.46875 10.1578 0.398438 11.25H1.90312ZM3.01406 7.33594C3.37969 6.6375 3.82031 5.98594 4.33125 5.39062L3.26719 4.32656C2.625 5.05781 2.07187 5.86406 1.63125 6.74063L3.01406 7.33594ZM18.6094 19.6688C17.9578 20.2313 17.2312 20.7141 16.4484 21.0938L17.0062 22.4906C17.9766 22.0266 18.8719 21.4313 19.6734 20.7281L18.6094 19.6688ZM5.39062 4.33125C6.04219 3.76875 6.76875 3.28594 7.55156 2.90625L6.99375 1.50938C6.02344 1.97344 5.12813 2.56875 4.33125 3.27188L5.39062 4.33125ZM20.9859 16.6641C20.6203 17.3625 20.1797 18.0141 19.6688 18.6094L20.7328 19.6734C21.375 18.9422 21.9281 18.1313 22.3688 17.2594L20.9859 16.6641ZM22.0969 12.75C22.0312 13.6313 21.8531 14.4844 21.5766 15.2859L22.9594 15.8766C23.3109 14.8875 23.5312 13.8375 23.5969 12.7453H22.0969V12.75ZM15.0563 21.6562C14.3203 21.8906 13.5469 22.0406 12.75 22.0969V23.6016C13.7437 23.5359 14.7047 23.3484 15.6141 23.0531L15.0563 21.6562ZM11.25 22.0969C10.3687 22.0312 9.51562 21.8531 8.71406 21.5766L8.12344 22.9594C9.1125 23.3109 10.1625 23.5312 11.2547 23.5969V22.0969H11.25ZM21.6562 8.94375C21.8906 9.67969 22.0406 10.4531 22.0969 11.25H23.6016C23.5359 10.2563 23.3484 9.29531 23.0531 8.38594L21.6562 8.94375ZM4.33125 18.6094C3.76875 17.9578 3.28594 17.2312 2.90625 16.4484L1.50938 17.0062C1.97344 17.9766 2.56875 18.8719 3.27188 19.6734L4.33125 18.6094ZM12.75 1.90312C13.6313 1.96875 14.4797 2.14688 15.2859 2.42344L15.8766 1.04063C14.8922 0.689063 13.8422 0.46875 12.75 0.398438V1.90312ZM8.94375 2.34375C9.67969 2.10938 10.4531 1.95937 11.25 1.90312V0.398438C10.2563 0.464062 9.29531 0.651563 8.38594 0.946875L8.94375 2.34375ZM20.7328 4.32656L19.6688 5.39062C20.2313 6.04219 20.7141 6.76875 21.0984 7.55156L22.4953 6.99375C22.0312 6.02344 21.4359 5.12813 20.7328 4.32656ZM18.6094 4.33125L19.6734 3.26719C18.9422 2.625 18.1359 2.07187 17.2594 1.63125L16.6688 3.01406C17.3625 3.37969 18.0187 3.82031 18.6094 4.33125Z"
                        fill="#32CD30"
                      />
                      <path
                        d="M12 18.375C12.7249 18.375 13.3125 17.7874 13.3125 17.0625C13.3125 16.3376 12.7249 15.75 12 15.75C11.2751 15.75 10.6875 16.3376 10.6875 17.0625C10.6875 17.7874 11.2751 18.375 12 18.375Z"
                        fill="#32CD30"
                      />
                      <path
                        d="M12.3609 14.625H11.6109C11.3015 14.625 11.0484 14.3719 11.0484 14.0625C11.0484 10.7344 14.6765 11.0672 14.6765 9.00937C14.6765 8.07187 13.8422 7.125 11.9859 7.125C10.6219 7.125 9.90936 7.575 9.21092 8.47031C9.02811 8.70469 8.69061 8.75156 8.45154 8.58281L7.83748 8.15156C7.57498 7.96875 7.51404 7.59844 7.71561 7.34531C8.70936 6.07031 9.89061 5.25 11.9906 5.25C14.4422 5.25 16.5562 6.64687 16.5562 9.00937C16.5562 12.1781 12.9281 11.9859 12.9281 14.0625C12.9234 14.3719 12.6703 14.625 12.3609 14.625Z"
                        fill="#32CD30"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_111_3897">
                        <path d="M0 0H24V24H0V0Z" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <h6 class="ct_fs_24 ct_switzer_Semibold mt-4 mb-4 ct_text_4f4f4f">
                  3. Monitor & Protect
                </h6>
                <p
                  class="ct_text_clr_4B5563 mb-0 mx-auto"
                  style={{ maxWidth: "277px" }}
                >
                  Real-time monitoring with instant alerts, threat detection,
                  and automated security responses.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="about-v2-section ct_py_80">
        <div class="container">
          <div class="row align-items-center">
            {/* LEFT IMAGE BOX */}
            <div class="col-xxl-6 col-xl-6 col-lg-6">
              <div class="ct_about_img_wrapper">
                <img
                  src="/assets/img/lock_icon.png"
                  alt=""
                  class="ct_abt_lock"
                />
                <div class="ct_abt_left_img_div">
                  <img src="/assets/img/abt_img_1.jpg" alt="" />
                </div>
                <div class="ct_abt_right_img_div">
                  <div class="ct_abt_secure_cnt">
                    <h2 class="ct_fs_64 text-white ct_switzer_Semibold">
                      10K+
                    </h2>
                    <p class="mb-0 text-white ct_fs_20">Assets Secured</p>
                  </div>
                  <div class="ct_abt_right_btm_img">
                    <img src="/assets/img/abt_img_2.png" alt="" />
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div class="col-xxl-6 col-xl-6 col-lg-6 ">
              <div class="about-content">
                <span class="small-title">ABOUT US</span>

                <h2>
                  Protecting Assets With Trust,
                  <br />
                  Privacy, And Technology
                </h2>

                <p>
                  SecurPoint is a modern asset protection platform designed to
                  help individuals and businesses register, manage, and
                  safeguard valuable assets with confidence. Our system is built
                  around privacy, security, and transparency — giving you full
                  control at every step.
                </p>

                {/* Button */}
                <a
                  href="#"
                  class="ct_custom_btn_2 ct_fs_18 ct_switzer_Regular pe-2"
                >
                  Start Securing Assets
                  <span class="arrow-circle ms-3">
                    <i class="fa-solid fa-arrow-right"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="why-securepoint ct_py_80">
        <div class="container">
          <div class="row align-items-center">
            {/* LEFT IMAGE BOX */}
            <div class="col-lg-5 mb-5 mb-lg-0 mb-5 mb-lg-0 text-center">
              <div class="why-image-box">
                <img
                  src="/assets/img/choose_secure_point_img.png"
                  alt="SecurePoint"
                />
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div class="col-lg-7 mb-5 mb-lg-0 mb-5 mb-lg-0 ps-lg-4">
              <div class="why-content">
                <h2 class="ct_fs_32 mb-2 ct_switzer_Semibold">
                  Why Choose SecurPoint
                </h2>
                <div class="title-line my-3"></div>

                <p class="ct_fs_18 mb-4 mt-4" style={{ maxWidth: "624px" }}>
                  Built to protect what matters most — with advanced security,
                  smart technology, and complete peace of mind.
                </p>

                {/* Checklist */}
                <ul class="why-list">
                  <li>Military-Grade Encryption</li>
                  <li>Real-Time Monitoring</li>
                  <li>Global Compliance</li>
                  <li>Instant Recovery</li>
                  <li>Advanced Analytics</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </WebLaout>
  );
};

export default WebHome;
